<!-- code taken from: https://github.com/aislasq/vue-bulma-datatable-->
<template>
    <nav class="pagination is-centered" role="navigation" aria-label="pagination">
        <button class="pagination-previous" v-on:click="gotoPrev()" :disabled="isPreviousButtonDisabled">Previous</button>
      <ul class="pagination-list">
        <li>
          <a class="pagination-link is-current is-disabled" aria-label="Page 46" aria-current="page">{{pageIndex + 1}}</a>
        </li>
      </ul>
        <button class="pagination-next" v-on:click="gotoNext()" :disabled="isNextButtonDisabled">Next page</button>

      </nav>
    <div class="table-container">
        <table :class="tableClass" style="border: 2px solid black;">
            <thead>
                <tr style="background-color: #00d1b2;">
                    <slot v-for="column in columns" :name="'table-header-' + column.field" :column="column">
                        <th :class="column.headClass" @click="toggleSort(column)" :width="column.width || ''" style="border: 2px solid black;">
                            <div class="column-controls">
                                <span>{{ column.label }}</span>
                                <span class="icon is-small" v-if="column.sortable">
                                    <i v-if="sort.column == column.field && sort.desc" class="fas fa-arrow-circle-down" aria-hidden="true"></i>
                                    <i v-else-if="sort.column == column.field && !sort.desc" class="fas fa-arrow-circle-up"></i>
                                    <i class="fas fa-sort" v-else></i>
                                </span>
                            </div>
                        </th>
                    </slot>
                </tr>
            </thead>
            <tbody>
                <tr v-if="filterRow">
                    <td v-for="column in columns" :class="column.bodyClass">
                        <input v-if="column.filterable" type="text" class="input" :placeholder="'Filter ' + column.label" @input="filterData(column, $event.target.value.toUpperCase())">
                    </td>

<!--                    <td v-else :class="column.bodyClass"></td>-->
                </tr>

                <tr v-for="(row, index) in showedRowsOfCurrPage" @click="rowClick(index)">
                    <slot name="table-body" :row="row">
                        <td v-for="column in columns" :class="column.bodyClass">
                          <span v-if="column.message_button">
                            <!-- {{ row.user.uid }} -->
                            <!-- <Messages v-bind:profile_uid="row.profile_uid" v-bind:user_role="row.user_role"/> -->
                            <router-link v-bind:to="{ name: 'RfcMessages', params: { profile_uid: row.user.uid, user_role: row.user_role }}" class="hyperlink">
								<button class="button is-primary">
                                    Messages 
                                    ({{ row.unread_messages }})
                                </button>
							</router-link>
                          </span>
                          <span v-else-if="column.field == 'user'">
                            <router-link v-if="column.is_mentor" v-bind:to="{ name: 'MentorProfilePage', params: { profile_uid: row.user.uid } }" class="hyperlink">
								{{ row.user.name}}
							</router-link>
                            <router-link v-if="column.is_mentee" v-bind:to="{ name: 'MenteeProfilePage', params: { profile_uid: row.user.uid } }" class="hyperlink">
								{{ row.user.name}}
							</router-link>
                          </span>
                          <span v-else-if="column.block_button">
                            <button v-if="row.is_blocked" v-on:click="$emit('block', index)" class="button is-info">UnBlock</button>
                            <button v-else v-on:click="$emit('block', index)" class="button is-danger">Block</button>
                          </span>
                          <span v-else>{{ row[column.field] }} </span>
                        </td>
<!--                        <td v-if="column.message_button" :class="column.bodyClass">-->
<!--                          <input type="text" class="input" :placeholder="'Filter ' + column.label">-->
<!--                        </td>-->
                    </slot>
                </tr>
            </tbody>
        </table>
    </div>

</template>

<script>
    import Messages from "../../components/common/Messages.vue";
    export default{
        components: {
            Messages,
        },
        props:{
            rows: {
                type: Array,
                required: true
            },
            columns: {
                type: Array,
                required: true
            },
            tableClass: {
                type: String,
                required: false,
                default: 'table'
            },
            click: {
                required: false,
                type: Boolean,
                default: false
            }
        },
        data: function(){
            return {
                pageSize: 10,
                pageIndex: 0,
                sort: {
                    column: '',
                    desc: true
                },
                filters: [],
                showedRows: [],
            }
        },
        watch: {
            rows: function(){
                this.showedRows = JSON.parse(JSON.stringify(this.rows));
            }
        },
        mounted: function () {
            this.showedRows = JSON.parse(JSON.stringify(this.rows));
        },
        computed: {
            filterRow: function () {
                return this.columns.findIndex( (e) => e.filterable ) >= 0;
            },
            pages: function () {
              if(this.showedRows.length % this.pageSize === 0){
                return this.showedRows.length / this.pageSize
              }
              return Math.floor(this.showedRows.length / this.pageSize) + 1
            },
            showedRowsOfCurrPage: function () {
              console.log(this.pages)
              return this.showedRows.slice(this.pageSize * this.pageIndex, this.pageSize * (this.pageIndex+1))
            },
            isPreviousButtonDisabled() {
                return this.pageIndex<1
              },
            isNextButtonDisabled() {
              console.log(this.pages)
                return this.pageIndex>this.pages-2
              },
        },
        methods:{
            gotoPrev: function() {this.pageIndex -=1},
            gotoNext: function() {this.pageIndex +=1},
            rowClick: function (row) {
                console.log(row)
                this.$emit('row_click', row);
            },
            toggleSort: function(column){
                if(column.sortable){
                    if (column.field === this.sort.column) {
                        this.sort.desc = !this.sort.desc;
                    } else {
                        this.sort.column = column.field;
                        this.sort.desc = true;
                    }
                    this.sortData();
                }
            },
            sortData() {
                this.showedRows = this.showedRows.sort(
                    (a, b) => {
                        if(a[this.sort.column] > b[this.sort.column]){
                            return 1;
                        }
                        else if(a[this.sort.column] < b[this.sort.column]){
                            return -1;
                        }
                        return 0;
                    }
                );

                if (!this.sort.desc) {
                    this.showedRows.reverse();
                }
            },
            filterData(column, query) {
                if (column === undefined || this.rows === undefined || query === undefined) {
                    this.filters = [];
                    this.applyFilters();
                    return;
                }
                let index = this.filters.findIndex( (e) => e.field === column.field );
                if(query === ""){
                    if(index !== -1) this.filters.splice(index, 1);
                }
                else{
                    if(index >= 0 ){
                        this.filters[index].query = query;
                    }
                    else{
                        this.filters.push({field: column.field, query: query});
                    }
                }
                this.applyFilters();
            },
            applyFilters: function () {
                this.showedRows = this.rows;
                if(this.filters.length === 0) return;

                this.filteredRows = [];
                this.filters.forEach(
                    (f) =>{
                        this.filteredRows = [];
                        this.showedRows.forEach( (row) => {
                            let search = f.query.toUpperCase().trim();
                            if (row[f.field].name.toUpperCase().indexOf(search) !== -1) {
                                this.filteredRows.push(row);
                            }
                        });
                        this.showedRows = this.filteredRows;
                    }
                );
                this.sortData();
            }
        },
        // emits: ['row_click', 'block'],
    }

</script>